module.exports = __webpack_public_path__ + "static/media/COVID-Icons_Cough.aa673842.png";